module.exports = __webpack_public_path__ + "officialStatic/img/detail-self3.88667e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-self3.png
// module id = qGFV
// module chunks = 0